import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useCart } from "@/context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [polls, setPolls] = useState(0);
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    let tries = 0;

    const poll = async () => {
      tries += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data);
        setPolls(tries);
        if (data.payment_status === "paid") { clear(); return; }
        if (tries < 20) setTimeout(poll, 2000);
      } catch {
        if (tries < 20 && !cancelled) setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const paid = status?.payment_status === "paid";

  return (
    <div className="container-app px-6 py-20 grid place-items-center">
      <div className="max-w-md w-full text-center bg-white rounded-2xl border border-gray-100 p-10">
        {paid ? (
          <>
            <CheckCircle2 size={64} className="mx-auto text-[#638971]"/>
            <h1 data-testid="payment-success-title" className="mt-4 font-heading text-3xl font-bold text-[#1A1A1A]">Payment received</h1>
            <p className="text-[#595959] mt-2">Your order is confirmed. We're preparing your supplies.</p>
            <div className="mt-6 flex gap-3 justify-center">
              <Link to="/orders" data-testid="view-orders-btn">
                <Button className="rounded-full bg-[#638971] hover:bg-[#4F705B] text-white">View orders</Button>
              </Link>
              <Link to="/products" data-testid="continue-shopping-btn">
                <Button variant="outline" className="rounded-full">Continue shopping</Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <Loader2 size={48} className="mx-auto text-[#638971] animate-spin"/>
            <h1 className="mt-4 font-heading text-2xl font-bold text-[#1A1A1A]">Confirming your payment…</h1>
            <p className="text-[#595959] mt-2 text-sm">This usually takes a few seconds.</p>
          </>
        )}
      </div>
    </div>
  );
}
